import React from "react";

const Loading = () => (
    <div id="loading">
        <img src="loading.gif" />
    </div>
);

export default Loading;
